import React from 'react';
import { Button } from '../shared/Button';
import { Card } from '../shared/Card';
interface EnvironmentProps {
  selected: string[];
  onSelect: (value: string[]) => void;
  onNext: () => void;
  onBack: () => void;
}
export const Environment = ({
  selected,
  onSelect,
  onNext,
  onBack
}: EnvironmentProps) => {
  const environmentOptions = [{
    value: 'none',
    label: 'None',
    emoji: '🧘',
    description: 'Just your body weight'
  }, {
    value: 'bands',
    label: 'Bands & Weights',
    emoji: '🏋️',
    description: 'Exercises with bands'
  }, {
    value: 'chair',
    label: 'Chair',
    emoji: '🪑',
    description: 'Using a chair for support'
  }, {
    value: 'space',
    label: 'Space',
    emoji: '🏃',
    description: 'Room to move around'
  }];
  const toggleSelection = (value: string) => {
    if (selected.includes(value)) {
      onSelect(selected.filter(item => item !== value));
    } else {
      onSelect([...selected, value]);
    }
  };
  return <div className="flex flex-col h-full p-6" data-id="element-723">
      <div className="mb-6" data-id="element-724">
        <button onClick={onBack} className="text-gray-500 mb-4" data-id="element-725">
          ← Back
        </button>
        <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-726">
          What's your workout setup typically like?
        </h1>
        <p className="text-gray-600" data-id="element-727">
          We'll recommend exercises that work in your space.
        </p>
      </div>
      <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-728">
        {environmentOptions.map(option => <Card key={option.value} onClick={() => toggleSelection(option.value)} active={selected.includes(option.value)} className="p-4 flex flex-col items-center text-center" data-id="element-729">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-2 text-2xl" data-id="element-730">
              {option.emoji}
            </div>
            <h3 className="font-medium" data-id="element-731">{option.label}</h3>
            <p className="text-gray-500 text-xs mt-1" data-id="element-732">{option.description}</p>
          </Card>)}
      </div>
      <div className="mt-auto" data-id="element-733">
        <Button onClick={() => {
        if (selected.length > 0) {
          onNext();
        }
      }} variant="primary" fullWidth disabled={selected.length === 0} className={selected.length === 0 ? 'opacity-50 cursor-not-allowed' : ''} data-id="element-734">
          Continue
        </Button>
      </div>
    </div>;
};